module.exports = __webpack_public_path__ + "img/scan.615d1e47.svg";